import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Card, CardHeader, CardBody, Row, Col } from "shards-react";
import GaugeChart from "react-gauge-chart"; // Import Gauge Chart
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'; // Import FontAwesome
import { faMobileAlt, faFingerprint, faBatteryFull, faPlug, faWifi, faNetworkWired, faAndroid, faApple } from '@fortawesome/free-solid-svg-icons'; // Import specific icons
import "../../views/loaderStyles.css"; // Import the loader styles
import { useAuth } from '../../context/AuthContext';
const UserDetails = ({ uuid }) => {
  const [deviceInfo, setDeviceInfo] = useState(null);
  const [loading, setLoading] = useState(true); // For loading state
  const [error, setError] = useState(null); // For error handling
  const [health, setHealth] = useState(0); // State for health percentage
  const { logout } = useAuth(); 

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchDeviceData = async () => {
      try {

          //  const companyId = localStorage.getItem('company_id');
          const token = localStorage.getItem("token");
          //  const comp_id=localStorage.getItem('company_id');
           // const token=localStorage.getItem('token');
            
            if(!token||token==''){ 
             logout();
           }

   setIsLoading(true);
        const response = await fetch("https://vaptlabreport.com/shieldapi/device_info_per_uuid.php", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ uuid: [uuid] }), // Send the uuid in the request body
        });

        if (!response.ok) {
          throw new Error("Network response was not ok");
        }

        const data = await response.json();
        if (data.status === "success" && data.data.length > 0) {
          const deviceData = data.data[0];
          const deviceInformation = JSON.parse(deviceData.device_information);
          const deviceScore = parseFloat(data.device_score); // Extract device_score from API response
          const healthPercentage = (deviceScore / 120) * 100;

          setHealth(healthPercentage); // Update health state
          setDeviceInfo({
            uuid: deviceData?.UUID ?? "Unknown",
            app_name: deviceData?.app_name ?? "Unknown",
            android_api_level: deviceData?.android_api_level ?? "Unknown",
           deviceName: deviceData?.device_name ?? "Unknown",
            device_id: deviceData?.device_id ?? "Unknown",
            os: deviceData?.os ?? "Unknown",
            brand: deviceInformation?.brand ?? "Unknown",
            model: deviceInformation?.model ?? "Unknown",
            manufacturer: deviceInformation?.manufacturer ?? "Unknown",
            iosVersion: deviceInformation?.ios_version ?? "Unknown",
            ipAddress: deviceInformation["IP-Address"] ||  "Unknown" ,
            batteryLevel: deviceInformation?.battery?.batteryLevel  ??  "Unknown",
            isCharging: deviceInformation?.battery?.isCharging ?? "Unknown",
            wifiSSID: deviceInformation?.wifi?.wifiSSID ?? "Unknown",
            wifiSignalStrength: deviceInformation?.wifi?.signalStrength ?? "Unknown",
            androidVersion: deviceData?.android_version  ?? "Unknown",
          });
        }
	      else{
  
          setDeviceInfo({});

        
	      }
      } catch (error) {
        setError(error.message); // Set the error message if an error occurs
      } finally {
        setLoading(false); // Set loading to false after fetching
      }
    };

    if (uuid) {
      fetchDeviceData(); // Fetch data only if uuid is provided
    }
  }, [uuid]);

  // Function to determine the health value
  const healthValue = health / 100; // Normalize health value to a percentage (0 to 1)

  return (
    <Card small className="user-details mb-4">
      <CardHeader className="p-0 mb-4"> {/* Added margin-bottom here */}
        <div className="device-health-chart">
          {/* <GaugeChart
            id="device-health-gauge"
            nrOfLevels={300} // Increase levels for smooth gradient
            percent={healthValue}
            textColor="#000000" // Color of the text inside the gauge
            needleColor="#000000" // Color of the needle
            arcPadding={0} // No padding between arcs
            arcWidth={0.2} // Width of the arc
            style={{ height: "200px" }} // Adjust height as needed
            colors={[  "#00FF00", "#FFD700", "#FFA500","#FFA500", "#FF4500","#FF4500", "#FF0000"]} // Gradient from green to red
            animate={true} // Enable animation
            hideText={false} // Show percentage text
          /> */}


<GaugeChart
  id="device-health-gauge"
  nrOfLevels={300} // Smooth gradient with more levels
  percent={healthValue} // Value between 0 and 1
  textColor="#000000" // Text inside the gauge
  needleColor="#000000" // Needle color
  arcPadding={0} // No gaps between arcs
  arcWidth={0.2} // Thickness of the arc
  style={{ height: "200px" }} // Height of the chart
  colors={[
    "#FF0000", // Red
    "#FF4500", // Orange-red
    "#FFA500", // Orange
    "#FFD700", // Gold
    "#ADFF2F", // Green-yellow
    "#00FF00"  // Green
  ]} // Gradient colors
  animate={true} // Smooth animation
  hideText={false} // Show percentage text
/>


          {/* Number labels */}
          <div className="gauge-label-right">120</div>
          <div className="gauge-label-left">0</div>
          <div className="device-score-label">Device Score</div>
        </div>
      </CardHeader>

      <CardBody className="p-0" style={{ marginTop: "-25px" }}>

	     <h4 className="text-center m-0 mt-2 ">Model: {loading ? "Loading..." : deviceInfo?.deviceName ?? "Unknown"}</h4>
       

       <p className="text-center text-light m-0 mb-2">{loading ? "" : `OS: ${deviceInfo?.os ?? "unknown"}`}</p>
        {loading ? (
          <div className="loader-container">
            <div className="spinner"></div> {/* Loader within the card */}
          </div>
        ) : (
          <div className="user-details__user-data border-top border-bottom p-4">
            <Row className="mb-3">
              <Col className="w-50">
                <span><FontAwesomeIcon icon={faFingerprint} /> UUID</span>
                <span>{deviceInfo?.uuid ?? "Unknown"}</span>
              </Col>
              <Col className="w-50">
                <span><FontAwesomeIcon icon={faMobileAlt} /> Device_Id</span>
                <span>{deviceInfo?.device_id ?? "Unknown" }</span>
              </Col>
            </Row>
            <Row className="mb-3">
              <Col className="w-50">
                <span><FontAwesomeIcon icon={faMobileAlt} /> Brand</span>
                <span>{deviceInfo?.brand ?? "Unknown"}</span>
              </Col>
              <Col className="w-50">
                <span><FontAwesomeIcon icon={faMobileAlt} /> Model</span>
                <span>{deviceInfo?.model ?? "Unknown" }</span>
              </Col>
            </Row>
            <Row className="mb-3">
              <Col className="w-50">
                <span><FontAwesomeIcon icon={faMobileAlt} /> Manufacturer</span>
                <span>{deviceInfo?.manufacturer ?? "Unknown" } </span>
              </Col>
              <Col className="w-50">
                <span><FontAwesomeIcon icon={faNetworkWired} /> IP Address</span>
                <span>{deviceInfo?.ipAddress ?? "Unknown" }</span>
              </Col>
            </Row>
            <Row className="mb-3">
              <Col className="w-50">
                <span><FontAwesomeIcon icon={faBatteryFull} /> Battery Level</span>
                <span>{deviceInfo?.batteryLevel ?? "Unknown"}</span>
              </Col>
              <Col className="w-50">
                <span><FontAwesomeIcon icon={faPlug} /> Charging</span>
                <span>{deviceInfo.isCharging ? "Yes" : "No"}</span>
              </Col>
            </Row>
            <Row className="mb-3">
              <Col className="w-50">
                <span><FontAwesomeIcon icon={faWifi} /> WiFi SSID</span>
                <span>{deviceInfo?.wifiSSID ?? "Unknown"}</span>
              </Col>
              <Col className="w-50">
                <span><FontAwesomeIcon icon={faWifi} /> Signal Strength</span>
                <span>{deviceInfo?.wifiSignalStrength ?? "Unknown"}</span>
              </Col>
            </Row>
            <Row className="mb-3">
              <Col className="w-50">
                <span> Android Version</span>
                <span>{deviceInfo?.androidVersion ?? "Unknown"}</span>
              </Col>
              <Col className="w-50">
                <span> Android API Level</span>
                <span>{deviceInfo?.android_api_level ?? "Unknown"}</span>
              </Col>
            </Row>
          </div>
        )}
      </CardBody>
    </Card>
  );
};

UserDetails.propTypes = {
  uuid: PropTypes.string.isRequired,
  health: PropTypes.number.isRequired, // Added health prop type
};

export default UserDetails;
